import { takeLatest, call } from 'redux-saga/effects';
import { QUERY_SURVEY_AI } from './actions';
import { querySurveyAiRequest } from './sagas';

function* querySurveyAiSaga() {
  yield takeLatest(QUERY_SURVEY_AI, function* (action) {
    yield call(querySurveyAiRequest, action);
  });
}

export default [querySurveyAiSaga];
